import * as commons from './functions/common';
import * as native from './functions/native';

/**
 * as-is 네이티브 브릿지 to-be 등록
 * @returns
 */
function registerLegacyNativeBridgeFunctions(overwrite: boolean = true) {
    if (typeof window === 'undefined') {
        return;
    }

    Object.entries(native).forEach(([name, fn]) => {
        const exists = typeof (window as any)[name] === 'function';

        if (exists && !overwrite) {
            console.log(`# [legacy] skip common function: ${name}`);
            return;
        }

        (window as any)[name] = fn;

        console.log('# [legacy] MA30Native bridge registered', (window as any).MA30Native);
    });
}

/**
 * as-is 공통함수 to-be 등록
 * @param overwrite 함수 overwrite 여부
 * @returns
 */
function registerLegacyCommonFunctions(overwrite: boolean = true) {
    if (typeof window === 'undefined') {
        return;
    }

    Object.entries(commons).forEach(([name, fn]) => {
        const exists = typeof (window as any)[name] === 'function';

        if (exists && !overwrite) {
            console.log(`# [legacy] skip common function: ${name}`);
            return;
        }

        (window as any)[name] = fn;

        console.log(`# [legacy] registered common function: ${name}`);
    });
}

type GlobalFunctionMap = Record<string, (...args: any[]) => void>;

/**
 * react 컴포넌트 하위 함수를 전역 함수로 등록 한다.
 * useEffect에서 register 후 언마운트 후 필히 삭제
 * @param functions
 */
function registerGlobalFunctions(functions: GlobalFunctionMap) {
    Object.entries(functions).forEach(([name, fn]) => {
        if (typeof fn === 'function') {
            (window as any)[name] = fn;
        }
    });

    return () => {
        Object.keys(functions).forEach((name) => {
            delete (window as any)[name];
        });
    };
}

/**
 *
 */
function registerLegacyFunctions(overwrite: boolean = true) {
    registerLegacyNativeBridgeFunctions(overwrite);
    registerLegacyCommonFunctions(overwrite);
}

export {
    registerGlobalFunctions,
    registerLegacyCommonFunctions,
    registerLegacyFunctions,
    registerLegacyNativeBridgeFunctions,
};
